// extracted by mini-css-extract-plugin
export default {"serviceContent":"services_serviceContent__4aRZj","serviceCard":"services_serviceCard__w1quZ"};